import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-datetime.vue")),
  {
    Filter: defineAsyncComponent(() => import("./filter.vue")),
  },
);
